import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle, ServiceProviderSymbol, WixCodeSdkHandlersProviderSym } from '@wix/thunderbolt-symbols'
import { ComponentWrapperSymbol } from '@wix/thunderbolt-components-loader'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { pageInteractionsService, siteInteractionsService } from './interactionsService'
import { editorInteractionsService, editorPageInteractionsService } from './ds/interactionsService'
import { interactionsSdkProvider } from './sdk/interactionsSdkProvider'
import { InteractionsModelUpdatesHandlers } from './interactionsModelUpdatesHandlers'
import { InteractionsComponentWrapper } from './interactionsComponentWrapper'
import { Interactions } from './interactions'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteInteractionsService)
	bind(ComponentWrapperSymbol).to(InteractionsComponentWrapper)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler, LifeCycle.PageDidMountHandler).to(Interactions)
	bind(ServiceProviderSymbol).to(pageInteractionsService)
	bind(WixCodeSdkHandlersProviderSym).to(interactionsSdkProvider)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(editorInteractionsService)
	bind(ModelUpdatesHandlersImplementor).to(InteractionsModelUpdatesHandlers)
	bind(ComponentWrapperSymbol).to(InteractionsComponentWrapper)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler, LifeCycle.PageDidMountHandler).to(Interactions)
	bind(ServiceProviderSymbol).to(editorPageInteractionsService)
	bind(WixCodeSdkHandlersProviderSym).to(interactionsSdkProvider)
}
